import { render } from "./AcceuilPage.vue?vue&type=template&id=639e956c"
import script from "./AcceuilPage.vue?vue&type=script&lang=js"
export * from "./AcceuilPage.vue?vue&type=script&lang=js"

import "./AcceuilPage.vue?vue&type=style&index=0&id=639e956c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__